import openRolesJson from './openRoles.json';
import { OpenRole, OpenRolesSchema } from '../schemas/openRole';

export type { OpenRole };
export const OPEN_ROLES: OpenRole[] = OpenRolesSchema.parse(openRolesJson);
